import React, { useRef, useState } from 'react'
import { Modal } from './Modal'
import { Divide, Upload } from 'lucide-react'
import { Api } from '../Service/api'
import MatchFollowingEquation, { DifferenceAnswer } from '../Component/ManuallyGenerate/MatchFollowingEquation'
import LatexTextRendererMcq from '../helper/Mathmcq'
import McqFormation from '../Component/ManuallyGenerate/McqFormation'
import { Divider } from '@mui/material'
import { ErrorToast, SuccessToast } from './Toast'
import { getlocalStorage } from '../Service/api/configuration/localstorage'
import { useDispatch } from 'react-redux'
import { ACTIONS } from '../redux/actions'

const QuestionReportDetail = ({
    isModelOpen,
    setIsPurchaseModelOpen,
    queReportData,
}) => {
    const { question } = queReportData


    const handleModelClose = () => {
        setIsPurchaseModelOpen(false)
    }
    return (
        <div>
            <Modal
                title="Report Question"
                width="max-w-2xl"
                disabled={false}
                modalOpen={isModelOpen}
                onClose={handleModelClose}
            >
                <div style={{ maxHeight: "450px", overflow: "auto" }}>
                    <div className="mb-6 text-sm font-semibold py-3">
                        <div className=" mb-2 flex gap-2 ">
                            <div>Q.</div>
                            <div>
                                {question?.m_equation != 1 ?
                                    // **********************without m_equation*************************
                                    (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            <div style={{ fontWeight: '600' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: question?.finalquestion,
                                                }}
                                                className="table-container"
                                            />

                                            {(question?.option1_img || question?.option2_img || question?.option3_img || question?.option4_img || question?.finaloption1 || question?.finaloption2 || question?.finaloption3 || question?.finaloption4) && <McqFormation question={question} />}

                                            {(question?.qtype != "12" && question?.perfact_metch?.length > 0) &&
                                                <MatchFollowingEquation data={question} />
                                            }
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            {/* *****************************with m_equation********************************** */}
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: question?.finalquestion,
                                                }}
                                                style={{ width: "-webkit-fill-available" }}
                                                className="table-container"
                                            />

                                            <LatexTextRendererMcq
                                                text={question}
                                            />

                                            {/* match the following */}
                                            {(question?.qtype != "12" && question?.perfact_metch?.length > 0) &&
                                                <MatchFollowingEquation data={question} />
                                            }
                                        </div>

                                    )}
                            </div>
                        </div>
                        <div className="text-[#108EE3] flex gap-2 ">
                            <div>Ans.</div>
                            <div>
                                {question?.m_equation != 1 ?
                                    // **********************without m_equation*************************
                                    (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            {question?.qtype != "12" && <div style={{ fontWeight: '600' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: question?.finalAnswer,
                                                }}
                                                className="table-container"
                                            />}

                                            {(question?.qtype == "12" && question?.perfact_metch?.length > 0) &&
                                                <DifferenceAnswer data={question} />
                                            }
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            {/* *****************************with m_equation********************************** */}
                                            {question?.qtype != "12" && <div
                                                dangerouslySetInnerHTML={{
                                                    __html: question?.finalAnswer,
                                                }}
                                                style={{ width: "-webkit-fill-available" }}
                                                className="table-container"
                                            />}

                                            {/* match the following */}
                                            {(question?.qtype == "12" && question?.perfact_metch?.length > 0) &&
                                                <DifferenceAnswer data={question} />
                                            }
                                        </div>

                                    )}
                            </div>
                        </div>
                    </div>
                    <Divider style={{ margin: '10px 0px' }} />
                    <div className="mb-6">
                        <p className="font-medium mb-2">⮚ On this mistake you have submitted the report.</p>
                        <div className="flex flex-wrap gap-4">
                            {queReportData?.type}
                        </div>
                    </div>
                    <Divider style={{ margin: '10px 0px' }} />

                    <div className="mb-6">
                        <p className="font-medium mb-2">⮚ Your Uploaded Image Query.</p>
                        <div className="flex items-center justify-center w-full h-32 px-4 transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
                            <div className="flex items-center space-x-2">
                                <div style={{ position: 'relative' }}>
                                    <img
                                        src={queReportData?.image}
                                        alt="logo"
                                        className="max-h-28  rounded-md border-2 border-gray-300"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-6">
                        <label htmlFor="description" className="block font-medium mb-2">
                            ⮚ Description
                        </label>
                        <textarea
                            id="description"
                            rows={3}
                            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
                            placeholder="Youth Education"
                            value={queReportData?.description}
                            disabled={true}
                        ></textarea>
                    </div>

                    <div className="mb-6">
                        <label htmlFor="description" className="block font-medium mb-2">
                            ⮚ Comment
                        </label>
                        <textarea
                            id="description"
                            rows={3}
                            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
                            value={queReportData?.usercomment}
                            disabled={true}
                        ></textarea>
                    </div>
                    <Divider style={{ margin: '10px 0px' }} />
                    <div className="flex justify-center">
                        <span className="text-lg font-medium text-green-700">Status : {queReportData?.status}</span>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default QuestionReportDetail